import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { HiddenProps } from "@insite/mobius/Hidden";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductInformationContainerStyles {
    container?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    leftColumnInnerContainer?: GridContainerProps;
    partNumberGridItem?: GridItemProps;
    brandManufacturerGridItem?: GridItemProps;
    longDescriptionGridItem?: GridItemProps;
    availabilityGridItem?: GridItemProps;
    bottomGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    rightColumnGridItemHidden?: HiddenProps;
    productTitleGridItem?: GridItemProps;
    brandStyles?: ProductBrandStyles;
    borderDivider?: InjectableCss;
    addToListCpnGridItem?: GridItemProps;
}

export const containerStyles: ProductInformationContainerStyles = {
    leftColumnGridItem: {
        width: [12, 12, 12, 12, 12],
        css: css`
            overflow: hidden;
            direction: ltr;
        `,
    },
    partNumberGridItem: { width: [12, 12, 12, 7, 7] },
    brandManufacturerGridItem: { width: 12 },
    longDescriptionGridItem: { width: 12 },
    availabilityGridItem: { width: [12, 12, 12, 5, 5] },
    bottomGridItem: { width: 12 },
    addToListCpnGridItem: { width: [12, 12, 12, 8, 8] },
    rightColumnGridItem: {
        width: [0, 0, 3, 3, 3],
        css: css``,
    },
    rightColumnGridItemHidden: {
        below: "md",
        css: css`
            width: 100%;
            direction: ltr;
        `,
    },
    container: {
        css: css`
            direction: ltr;
            padding: 5px;
        `,
        offsetCss: css``,
    },
    productTitleGridItem: {
        width: 12,
    },
    brandStyles: {
        logoImage: {
            css: css`
                img {
                    max-width: 150px;
                    max-height: 150px;
                }
            `,
        },
        nameText: {
            size: 16,
            weight: "normal",
        },
    },
    borderDivider: {
        css: css`
            height: 1px;
            width: 100%;
            background-color: #bdbbbb;
            margin-left: 15px;
            margin-top: 5px;
            margin-right: 15px;
            margin-bottom: 5px;
        `,
    },
};

const styles = containerStyles;

const ProductInformationContainer: React.FC<Props> = ({ id, product }) => {
    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.brandManufacturerGridItem}>
                <Zone contentId={id} zoneName="BrandManufacturer" />
            </GridItem>
            <GridItem {...styles.longDescriptionGridItem}>
                <Zone contentId={id} zoneName="LongDescription" />
            </GridItem>
            <GridItem {...styles.partNumberGridItem}>
                <Zone contentId={id} zoneName="ProductPartNumbers" />
            </GridItem>
            <GridItem {...styles.availabilityGridItem}>
                <Zone contentId={id} zoneName="Availability" />
            </GridItem>
            <GridItem {...styles.bottomGridItem}>
                <Zone contentId={id} zoneName="Cart" />
            </GridItem>
            <GridItem {...styles.addToListCpnGridItem}>
                <Zone contentId={id} zoneName="AddToList" />
                <Zone contentId={id} zoneName="AddCPN" />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductInformationContainer),
    definition: {
        displayName: "Information Container",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
